<div class="flex-row flex-gap-4">
  {{ leftOption?.label }}<shared-switch [value]="selectedValue === rightOption.value" [mode]="'toggle'" [isDisabled]="isDisabled" (valueChange)="onValueChanged($event)"></shared-switch>{{
  rightOption?.label }}
</div>
